import { render, staticRenderFns } from "./CampoDivisa.vue?vue&type=template&id=ccc44822"
import script from "./CampoDivisa.vue?vue&type=script&lang=js"
export * from "./CampoDivisa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports